import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeProps as _mergeProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("visually-hidden__span-0bklod", {
  border: 0,
  clip: "rect(0px, 0px, 0px, 0px)",
  height: "1px",
  width: "1px",
  margin: "-1px",
  padding: 0,
  overflow: "hidden",
  whiteSpace: "nowrap",
  position: "absolute"
});
import React from 'react';
export type VisuallyHiddenProps = React.HTMLProps<HTMLDivElement>;

/**
 * A component to render text for screen-readers. A simple span with css rules to hide the text in an accessible way.
 *
 * @alias VisuallyHiddenProps
 * */
const VisuallyHidden = (props: VisuallyHiddenProps): JSX.Element => <span {..._mergeProps({
  css: _staticStyles
}, props)} />;
export default VisuallyHidden;